import Vue from 'vue';
import VueRouter from 'vue-router';
import { createBeforeEachHook, decorateRecords, getRecords, prepareRecord } from 'framework/router/helpers';

/**
 * Create the application routes from the global config
 * @return {Array} all the SPA routes
 */
function createRoutes() {
    return decorateRecords(getRecords(globals.config.router), [prepareRecord]);
}

/**
 * Initialize vue-router
 * @return {VueRouter} The app's root component
 */
function init() {
    const Log = Vue.log({ context: { location: 'vue-router' } });
    const initialRoute = `${ window.location.pathname }${ window.location.search }`;
    const router = new VueRouter({
        mode: 'history',
        routes: createRoutes(),
        linkActiveClass: 'u-router-link-active',
        linkExactActiveClass: 'u-router-link-exact-active',
    });

    // Call hook before every route transition
    router.beforeEach(createBeforeEachHook(Log, initialRoute));

    // Return the router
    return router;
}

export default init;
